import React, { useState, useContext } from 'react';
import Accordion from '../../../../../../components/Accordion/Accordion';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../../../../../../components/TextFields/DatePicker';
import { store } from './reducer';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import UsersChip from '../../../../../../components/Chip/UsersChip/UsersChip';
import useRules from 'hooks/useRules';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 4fr 1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    '& > *': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));

const Filters = () => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();

  const {
    state: { startDate, endDate, progress, customers, drivers, operators },
    dispatch,
  } = useContext(store);

  const handleChangeStartDate = (date) => {
    dispatch({ type: 'CHANGE_START_DATE', payload: date });
  };
  const handleChangeEndDate = (date) => {
    dispatch({ type: 'CHANGE_END_DATE', payload: date });
  };
  const handleChangeCheckbox = (e) => {
    const { checked, name } = e.target;
    dispatch({ type: 'CHANGE_CHECKBOXES', payload: { name, checked } });
  };
  const handleChangeUser = (user) => {
    dispatch({ type: 'CHANGE_USER', payload: user });
  };

  return (
    <Accordion title="فیلترهای گزارش" open={isMobile ? false : true}>
      <div className={classes.root}>
        <DatePicker
          label="از سال"
          value={startDate}
          onChange={handleChangeStartDate}
          disabled={progress}
          format={'jYYYY'}
        />
        <DatePicker
          label="تا سال"
          value={endDate}
          onChange={handleChangeEndDate}
          disabled={progress}
          format={'jYYYY'}
        />
        {hasRule('can_manage_operators') && <UsersChip single onChange={handleChangeUser} />}
        {hasRule('can_manage_operators') && <FormControlLabel
          control={
            <Checkbox
              checked={customers}
              onChange={handleChangeCheckbox}
              name="customers"
            />
          }
          label="صاحبین بار"
        />}
        {hasRule('can_manage_operators') && <FormControlLabel
          control={
            <Checkbox
              checked={drivers}
              onChange={handleChangeCheckbox}
              name="drivers"
            />
          }
          label="رانندگان"
        />}
        {hasRule('can_manage_operators') && <FormControlLabel
          control={
            <Checkbox
              checked={operators}
              onChange={handleChangeCheckbox}
              name="operators"
            />
          }
          label="کارشناسان حمل"
        />}
      </div>
    </Accordion>
  );
};

export default React.memo(Filters);
